import { Box, CircularProgress, Tabs, Tab } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Identity from '../../common/Filters/Identity'
import GenericLoadError from '../../common/GenericLoadError'
import useGenericEndpoint from '../../hooks/api/useGenericEndpoint'
import useIdentities from '../../hooks/api/useIdentities'
import useCurrentIdentity from '../../hooks/useCurrentIdentity'
import ActivityKPITable from './ActivityKPITable'
import Calendar from './Calendar'
import Goals from './Goals'
import Graphs from './Graphs'
import DatePicker from './DatePicker'

const Activity = () => {
  const { currentIdentity } = useCurrentIdentity()

  const [selectedIdentites, setSelectedIdentities] = useState([currentIdentity])

  const [tab, setTab] = useState(0)

  const today = new Date()

  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)

  const [startDate, setStartDate] = useState(firstDay.toLocaleDateString('sv'))
  const [endDate, setEndDate] = useState(lastDay.toLocaleDateString('sv'))

  useEffect(() => {
    setStartDate(firstDay.toLocaleDateString('sv'))
    setEndDate(lastDay.toLocaleDateString('sv'))
  }, [])

  const typesRequest = useGenericEndpoint('/api/activity/types')
  const goalsRequest = useGenericEndpoint('/api/activity/goals', {
    filters: {
      condensed: true,
      identity_ids: selectedIdentites.map((i) => i.id),
      fallback: tab !== 3,
    },
  })
  const activitiesRequest = useGenericEndpoint('/api/activity', {
    filters: {
      identity_ids: selectedIdentites.map((i) => i.id),
      condensed: true,
      start_date: startDate,
      end_date: endDate,
    },
  })

  const identitiesRequest = useIdentities()

  const handleTabChange = (e, val) => {
    setTab(val)
  }

  const handleIdentityChange = (val) => {
    setSelectedIdentities(val)
  }

  const isLoading =
    typesRequest.isLoading ||
    activitiesRequest.isLoading ||
    goalsRequest.isLoading ||
    identitiesRequest.isLoading

  const hasLoadError =
    typesRequest.hasLoadError ||
    activitiesRequest.hasLoadError ||
    goalsRequest.hasLoadError ||
    identitiesRequest.hasLoadError

  if (isLoading) return <CircularProgress />
  if (hasLoadError) return <GenericLoadError />

  return (
    <Box sx={{ flexGrow: 1, overflow: 'scroll' }}>
      <Tabs value={tab} onChange={handleTabChange}>
        <Tab label={'Goals'}></Tab>
        <Tab label={'KPIs'} />
        <Tab label={'Calendar'}></Tab>
        <Tab label={'Graphs'}></Tab>
      </Tabs>

      <Box sx={{ mb: 2, mt: 2 }}>
        <Identity
          placeholder={'People'}
          selectedIdentities={selectedIdentites}
          setSelectedIdentities={handleIdentityChange}
          multiple
        />
      </Box>

      {tab === 0 && (
        <Goals
          goals={goalsRequest.data?.condensedGoals}
          activityTypes={typesRequest.data?.activityTypes}
          identities={identitiesRequest.identities}
          selectedIdentites={selectedIdentites}
        />
      )}

      <>
        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          {tab === 1 && (
            <>
              <DatePicker
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
              />
              <ActivityKPITable
                activityTypes={typesRequest.data?.activityTypes}
                activities={activitiesRequest.data?.activitiesByIdentity}
                condensedGoals={goalsRequest.data?.condensedGoals}
                goalsByIdentity={goalsRequest.data?.goalsByIdentity}
                selectedIdentites={selectedIdentites}
                allActivitiesByIdentityIds={
                  activitiesRequest?.data.allActivitiesByIdentityIds
                }
              />
            </>
          )}
          {tab === 2 && (
            <>
              <Calendar
                activities={activitiesRequest.data?.activitiesByDate}
                activityTypes={typesRequest.data?.activityTypes}
              />
            </>
          )}
        </Box>
      </>

      {tab === 3 && (
        <Graphs
          activityTypes={typesRequest.data?.activityTypes}
          activities={activitiesRequest.data}
        />
      )}
    </Box>
  )
}

export default Activity
